import { put } from 'redux-saga/effects';

import { CreateDatasourceExtractTaskActionService } from '~src/extract/actions/CreateDatasourceExtractTaskAction';
import { CreateExtractTasksMode } from '~src/extract/actions/CreateExtractTaskAction';

import { Messages } from '../../../../codegen/Localize';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { CreateRemoteExtractRefreshAction } from '../../../actions/spaces/CreateRemoteExtractRefreshAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';

export function* handleCreateRemoteExtractRefreshAction(action: CreateRemoteExtractRefreshAction) {
  try {
    // Similar to the logic of openDatasourceRefreshExtractDialog
    // in $\src\vizportalclient\src\app\sagas\spaces\extractTasks\CreateExtractRefreshSaga.ts
    // such that clicking "New Extract Refresh" would open the same tabbed dialog
    CreateDatasourceExtractTaskActionService.forDatasource(action.datasource, CreateExtractTasksMode.AllowScheduleOnServerAndClient);
    yield put(requestSpaceContents());
  } catch(e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}